module.exports = __webpack_public_path__ + "images/emoji/bicyclist.2d8bb7a5289f56c7c8bd.png";